import { useState } from "react";
import AuthLayout from "@/components/auth/AuthLayout";
import SignInForm from "@/components/auth/SignInForm";
import SignUpForm from "@/components/auth/SignUpForm";
import { useLanguage } from "@/contexts/LanguageContext";
import { useTranslation } from "@/i18n/translations";

const Index = () => {
  const [isSignUp, setIsSignUp] = useState(false);
  const { language } = useLanguage();
  const { t } = useTranslation(language);

  const toggleForm = () => {
    setIsSignUp((prev) => !prev);
  };

  return (
    <AuthLayout
      title={isSignUp ? t("createAccount") : t("welcomeBack")}
      subtitle={
        isSignUp
          ? t("createAccountSubtitle")
          : t("signInCredentials")
      }
    >
      {isSignUp ? (
        <SignUpForm onToggle={toggleForm} />
      ) : (
        <SignInForm onToggle={toggleForm} />
      )}
    </AuthLayout>
  );
};

export default Index;
